import { install as installGTM } from '@libs/gtm';

import { VERSION } from '@/configs/env';
import vGid from '@/directives/gid';

let gtmId: string;

// GTM production & main stage
if (VERSION !== 'N/A') gtmId = 'GTM-5B42KXQ';

// GTM staging
if (VERSION === 'N/A') gtmId = 'GTM-5D98RH9';

const install = (app) => {
  app.directive('gid', vGid);

  installGTM(gtmId, VERSION);
};

export { install };
